/** Non-throwing: use before optional flows that can tolerate missing backend env. */
export function peekBackendConfig(): {
  url: string;
  anonKey: string;
} | null {
  const url = import.meta.env.VITE_INSFORGE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_INSFORGE_ANON_KEY as string | undefined;
  if (url?.trim() && anonKey?.trim()) {
    return { url: url.trim(), anonKey: anonKey.trim() };
  }

  return null;
}

/** Reads required InsForge browser configuration or throws when either value is missing. */
export function readBackendConfig(): { url: string; anonKey: string } {
  const config = peekBackendConfig();
  if (!config) {
    throw new Error(
      "Missing backend configuration. Set VITE_INSFORGE_URL and VITE_INSFORGE_ANON_KEY for the Cloudflare Pages build and local Vite.",
    );
  }
  return config;
}
